import React, { useState } from 'react';
import './AboutMusic.css';

function AboutMusic() {
  const [activeSection, setActiveSection] = useState('fundamentals');

  const sections = {
    fundamentals: {
      title: "Production vs Mixing Fundamentals",
      content: (
        <div className="content-section active">
          <h2 className="section-title">Production vs Mixing Fundamentals</h2>
          <div className="content-grid">
            <div className="content-card">
              <h3 className="card-title">Music Production</h3>
              <div className="card-subtitle">Creative Foundation</div>
              <ul className="feature-list">
                <li>Creative arrangement and composition</li>
                <li>Sound design and synthesis</li>
                <li>MIDI programming and sequencing</li>
                <li>Artist direction and vision execution</li>
                <li>Loop-based composition techniques</li>
                <li>Layering and texture building</li>
                <li>Collaborative production workflows</li>
              </ul>
            </div>

            <div className="content-card">
              <h3 className="card-title">Mixing</h3>
              <div className="card-subtitle">Technical Refinement</div>
              <ul className="feature-list">
                <li>Balancing individual tracks</li>
                <li>EQ, compression, and effects processing</li>
                <li>Spatial placement and stereo imaging</li>
                <li>Final polish before mastering</li>
                <li>Frequency spectrum management</li>
                <li>Dynamic range optimization</li>
                <li>Professional mixing standards</li>
              </ul>
            </div>
          </div>
        </div>
      )
    },
    strategies: {
      title: "Technical Strategies & Workflows",
      content: (
        <div className="content-section">
          <h2 className="section-title">Technical Strategies & Workflows</h2>
          <div className="content-grid">
            <div className="content-card">
              <h3 className="card-title">Ableton Live Production</h3>
              <div className="card-subtitle">Digital Audio Workstation Mastery</div>
              <ul className="feature-list">
                <li>Session vs Arrangement view workflows</li>
                <li>Clip launching and live performance</li>
                <li>Audio warping and time manipulation</li>
                <li>Instrument rack design</li>
                <li>Wavetable synthesis fundamentals</li>
                <li>Operator FM synthesis</li>
                <li>Max for Live integration</li>
                <li>Audio effect chains</li>
              </ul>
            </div>

            <div className="content-card">
              <h3 className="card-title">DJ Mixing (Pioneer DDJ)</h3>
              <div className="card-subtitle">Live Performance Techniques</div>
              <ul className="feature-list">
                <li>Beatmatching and tempo sync</li>
                <li>Phrase matching and musical structure</li>
                <li>EQ isolation techniques</li>
                <li>Effects timing and musical phrasing</li>
                <li>Harmonic mixing (Camelot wheel)</li>
                <li>Loop rolling and stutter effects</li>
                <li>Filter sweeps and build-ups</li>
                <li>Crowd reading and energy management</li>
              </ul>
            </div>
          </div>
        </div>
      )
    },
    equipment: {
      title: "Equipment & Software Guide",
      content: (
        <div className="content-section">
          <h2 className="section-title">Equipment & Software Guide</h2>
          <div className="content-grid">
            <div className="content-card">
              <h3 className="card-title">Essential Hardware</h3>
              <div className="card-subtitle">Studio Setup</div>
              <ul className="feature-list">
                <li>Audio interfaces and converters</li>
                <li>Studio monitors and headphones</li>
                <li>MIDI controllers and keyboards</li>
                <li>Microphones and preamps</li>
                <li>Acoustic treatment solutions</li>
                <li>Hardware synthesizers</li>
                <li>Effects processors</li>
              </ul>
            </div>

            <div className="content-card">
              <h3 className="card-title">Software Solutions</h3>
              <div className="card-subtitle">Digital Tools</div>
              <ul className="feature-list">
                <li>Digital Audio Workstations (DAWs)</li>
                <li>Virtual instruments and plugins</li>
                <li>Audio effects and processors</li>
                <li>Sample libraries and sound banks</li>
                <li>Music notation software</li>
                <li>Audio analysis tools</li>
                <li>Collaboration platforms</li>
              </ul>
            </div>
          </div>
        </div>
      )
    }
  };

  return (
    <div className="about-music">
      <div className="container">
        <header className="header">
          <div className="header-content">
            <div>
              <h1 className="header-title">Music Production Academy</h1>
              <p className="header-subtitle">Interactive Learning Platform</p>
            </div>
            <div className="audio-visualizer">
              {[...Array(8)].map((_, i) => (
                <div key={i} className="bar"></div>
              ))}
            </div>
          </div>
        </header>

        <nav className="nav-container">
          <div className="nav-grid">
            <button 
              className={`nav-btn ${activeSection === 'fundamentals' ? 'active' : ''}`}
              onClick={() => setActiveSection('fundamentals')}
            >
              Production vs Mixing
            </button>
            <button 
              className={`nav-btn ${activeSection === 'strategies' ? 'active' : ''}`}
              onClick={() => setActiveSection('strategies')}
            >
              Technical Strategies
            </button>
            <button 
              className={`nav-btn ${activeSection === 'equipment' ? 'active' : ''}`}
              onClick={() => setActiveSection('equipment')}
            >
              Equipment & Software
            </button>
          </div>
        </nav>

        {sections[activeSection].content}
      </div>
    </div>
  );
}

export default AboutMusic;